/* ============================================================
   Homepage, phone: the navbar logo emerges from the hero

   At the top of the homepage the hero already shows the brand
   mark, large and centred. Repeating it in the bar directly above
   is the same logo twice within 60px of screen.

   So the bar starts bare and the mark fades in once the hero's
   own cartouche has scrolled away — the logo appears to rise out
   of the hero into the bar.

   IntersectionObserver, not a scroll listener: it fires only when
   the hero mark actually crosses the threshold, instead of running
   a handler on every scroll frame. The class goes on <html> so the
   CSS can be written without JS knowing anything about styling.

   Scoped in three ways, each checked before anything is observed:
     - homepage only      (body.template-index)
     - phone only         (matchMedia, re-checked on resize)
     - only when the hero actually renders a brand mark
   Anything else leaves the bar exactly as it was.
   ============================================================ */

(function () {
  'use strict';

  var PHONE = '(max-width: 767px)';

  /* Announce that the script is alive. The CSS only hides the logo
     when this class is present, so a blocked or failed script leaves
     the bar exactly as it was rather than permanently bare. Set
     immediately, before any other work. */
  document.documentElement.classList.add('deshio-nav-logo-js');
  var CLASS = 'deshio-nav-logo-ready';
  var observer = null;

  function heroMark() {
    return document.querySelector('.deshio-hero__brand');
  }

  function show(on) {
    document.documentElement.classList.toggle(CLASS, !!on);
  }

  function stop() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    // Leaving the class on would hide the logo forever on a width
    // where this behaviour does not apply.
    show(true);
  }

  function start() {
    var mark = heroMark();
    if (!mark || observer) return;

    // Hidden to begin with: the hero mark is on screen at load.
    show(false);

    observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          // Gone from view -> the bar takes over the logo.
          show(!entries[i].isIntersecting);
        }
      },
      {
        // Fire when the mark passes behind the bar rather than when
        // it leaves the viewport, so the handover happens at the
        // moment it disappears under the header.
        rootMargin: '-72px 0px 0px 0px',
        threshold: 0
      }
    );

    observer.observe(mark);
  }

  function sync() {
    var applies =
      document.body &&
      document.body.classList.contains('template-index') &&
      !!heroMark();

    if (applies) start();
    else stop();
  }

  function init() {
    // No IntersectionObserver (very old browsers): leave the logo
    // visible rather than hiding something that can never come back.
    if (!('IntersectionObserver' in window)) {
      show(true);
      return;
    }
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Rotating a phone, or resizing on desktop, changes whether this
  // applies at all.
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(sync, 150);
  });
})();
